import { Box, Switch, DialogBody, DialogClose, DialogHeader, openModal } from '@ff-it/ui';
import { ReactElement, useCallback, useState } from 'react';
import { Summary } from './Summary';
import { planRowsAtoms } from '../../state/plan';
import { useAtomCallback } from 'jotai/utils';
import { PlanRow } from 'modules/campaign/row';

function SummaryDialog({ rows }: { rows: PlanRow[] }): ReactElement {
  const [showMonths, setShowMonths] = useState<boolean>(false);

  return (
    <>
      <DialogHeader title="Plan summary">
        <Box ml="3" display="flex" alignItems="center">
          <Switch checked={showMonths} onChange={(e) => setShowMonths(e.target.checked)} id="expand-months" size="sm" />
          <Box as="label" htmlFor="expand-months" mb="0" ml="2" fontSize="sm" userSelect="none">
            Expand months
          </Box>
        </Box>
        <DialogClose className="ml-auto" size="sm" />
      </DialogHeader>
      <DialogBody>
        <Summary showMonths={showMonths} rows={rows} />
      </DialogBody>
    </>
  );
}

export function useOnOpenSummary(): () => void {
  return useAtomCallback(
    useCallback((get) => {
      const rows = get(planRowsAtoms);
      openModal(() => <SummaryDialog rows={rows} />, {
        testId: 'summary',
        className: 'right',
      });
    }, []),
  );
}
